import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "cart",
  "use": "cart-usage",
  "viewBox": "0 0 20 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 18\" id=\"cart\">\n  <path fill-rule=\"evenodd\" d=\"M86.333,474.062H83.5a0.858,0.858,0,0,0-.073-0.165l-2.778-4.5a0.832,0.832,0,0,0-1.541.446,0.851,0.851,0,0,0,.126.447l2.329,3.772H74.434l2.329-3.772a0.851,0.851,0,0,0,.126-0.447,0.832,0.832,0,0,0-1.541-.446l-2.778,4.5a0.871,0.871,0,0,0-.073.165H69.667A1.678,1.678,0,0,0,68,475.75v1.125a1.68,1.68,0,0,0,1.287,1.639L71.4,485.79A1.671,1.671,0,0,0,73,487H83a1.671,1.671,0,0,0,1.6-1.21l2.113-7.276A1.68,1.68,0,0,0,88,476.875V475.75A1.678,1.678,0,0,0,86.333,474.062ZM69.667,475.75H86.333v1.125H69.667V475.75ZM83,485.312H73l-1.96-6.751H84.961Z\" transform=\"translate(-68 -469)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/cart.svg
// module id = null
// module chunks = 